import axios from "axios";

import URLS from "../../util/urls.js";
import widgets from "./util/widgets.js";

import GruposPermissoes from './util/gruposPermissoes.js';

const state = {
  perfilPesquisa: { nome: undefined, pagina: 0 },
  listaPerfis: [],
  labelQuantidade: '',
  perfilSelecionado: {
    id: 0,
    nome: undefined,
    permissoes: [
      { modulo: 'CLIENTES_ALUGUEL' },
      { modulo: 'IMOVEIS_ALUGUEL' },
      { modulo: 'CONTRATOS_ALUGUEL' },
      { modulo: 'RELATORIOS_CLIENTES_ALUGUEL' },
      { modulo: 'RELATORIOS_CONTRATOS_ALUGUEL' },
      { modulo: 'RELATORIOS_IMOVEIS_ALUGUEL' },
      { modulo: 'RELATORIOS_PRETENDENTES_ALUGUEL' },
      { modulo: 'RELATORIOS_FINANCEIROS_ALUGUEL' },
      { modulo: 'CLIENTES_VENDA' },
      { modulo: 'CONTRATOS_VENDA' },
      { modulo: 'IMOVEIS_VENDA' },
      { modulo: 'RELATORIOS_CAPTACOES_VENDA' },
      { modulo: 'RELATORIOS_COMISSOES_VENDA' },
      { modulo: 'RELATORIOS_CLIENTES_VENDA' },
      { modulo: 'RELATORIOS_IMOVEIS_VENDA' },
      { modulo: 'RELATORIOS_PRETENDENTES_VENDA' },
      { modulo: 'CONTAS_RECEBER' },
      { modulo: 'LANCAMENTOS_CONTAS_RECEBER' },
      { modulo: 'CONTAS_PAGAR' },
      { modulo: 'LANCAMENTOS_CONTAS_PAGAR' },
      { modulo: 'CAIXA' },
      { modulo: 'FORNECEDORES' },
      { modulo: 'PLANOS_CONTA' },
      { modulo: 'GRUPOS_CONTA' },
      { modulo: 'PRETENDENTES' },
      { modulo: 'ADMINISTRADORAS' },
      { modulo: 'CONDOMINIOS' },
      { modulo: 'PLACAS' },
      { modulo: 'USUARIOS' },
      { modulo: 'PERFIS_USUARIOS' },
      { modulo: 'CONTAS_BANCARIAS' },
      { modulo: 'PORTAIS' },
      { modulo: 'LOGS' },
      { modulo: 'VISITA' },
      { modulo: 'SISTEMA' }
    ],
    widgets: {}
  },
  grupoAluguelClientesCheckAll: false,
  grupoAluguelClientesChecklist: [],

  grupoAluguelBaixaCheckAll: false,
  grupoAluguelBaixaChecklist: [],

  grupoAluguelLiberacaoRepasseCheckAll: false,
  grupoAluguelLiberacaoRepasseChecklist: [],

  grupoAluguelImoveisCheckAll: false,
  grupoAluguelImoveisChecklist: [],

  grupoAluguelContratosCheckAll: false,
  grupoAluguelContratosChecklist: [],

  grupoAluguelReajusteCheckAll: false,
  grupoAluguelReajusteChecklist: [],

  grupoAluguelVencimentoCheckAll: false,
  grupoAluguelVencimentoChecklist: [],

  grupoRelatoriosClientesChecklist: [],

  grupoRelatoriosContratosCheckAll: false,
  grupoRelatoriosContratosChecklist: [],

  grupoRelatoriosImoveisCheckAll: false,
  grupoRelatoriosImoveisChecklist: [],

  grupoRelatoriosPretendentesChecklist: [],

  grupoRelatoriosFinanceirosCheckAll: false,
  grupoRelatoriosFinanceirosChecklist: [],

  grupoVendaClientesCheckAll: false,
  grupoVendaClientesChecklist: [],

  grupoVendaImoveisCheckAll: false,
  grupoVendaImoveisChecklist: [],

  grupoVendaContratosCheckAll: false,
  grupoVendaContratosChecklist: [],

  grupoVendaRelatoriosCheckAll: [],
  grupoVendaRelatoriosChecklist: [],

  grupoFinanceiroContasReceberCheckAll: false,
  grupoFinanceiroContasReceberChecklist: [],

  grupoFinanceiroLancamentosReceberCheckAll: false,
  grupoFinanceiroLancamentosReceberChecklist: [],

  grupoFinanceiroContasPagarCheckAll: false,
  grupoFinanceiroContasPagarChecklist: [],

  grupoFinanceiroLancamentosPagarCheckAll: false,
  grupoFinanceiroLancamentosPagarChecklist: [],

  grupoFinanceiroCaixaCheckAll: false,
  grupoFinanceiroCaixaChecklist: [],

  grupoFinanceiroFornecedoresCheckAll: false,
  grupoFinanceiroFornecedoresChecklist: [],

  grupoFinanceiroPlanosContaCheckAll: false,
  grupoFinanceiroPlanosContaChecklist: [],

  grupoFinanceiroGruposContaCheckAll: false,
  grupoFinanceiroGruposContaChecklist: [],

  grupoFinanceiroRelatoriosCheckAll: false,
  grupoFinanceiroRelatoriosChecklist: [],

  grupoConfiguracoesPretendentesCheckAll: false,
  grupoConfiguracoesPretendentesChecklist: [],

  grupoConfiguracoesCondominiosCheckAll: false,
  grupoConfiguracoesCondominiosChecklist: [],

  grupoConfiguracoesAdministradorasCheckAll: false,
  grupoConfiguracoesAdministradorasChecklist: [],

  grupoConfiguracoesUsuariosCheckAll: false,
  grupoConfiguracoesUsuariosChecklist: [],

  grupoConfiguracoesPerfisCheckAll: false,
  grupoConfiguracoesPerfisChecklist: [],

  grupoConfiguracoesPlacasCheckAll: false,
  grupoConfiguracoesPlacasChecklist: [],

  grupoConfiguracoesContasCheckAll: false,
  grupoConfiguracoesContasChecklist: [],

  grupoConfiguracoesPortaisCheckAll: false,
  grupoConfiguracoesPortaisChecklist: [],

  grupoConfiguracoesLogsCheckAll: false,
  grupoConfiguracoesLogsChecklist: [],

  grupoConfiguracoesVisitasCheckAll: false,
  grupoConfiguracoesVisitasChecklist: [],

  grupoConfiguracoesSistemaCheckAll: false,
  grupoConfiguracoesSistemaChecklist: []
};
const mutations = {
  atualizarListaPerfis(state, payload) {
    if(state.perfilPesquisa.pagina === 0) {
      state.listaPerfis = payload.lista;
    } else {
      state.listaPerfis.push(...payload.lista);
    }
    switch(payload.quantidade) {
      case 0:
        state.labelQuantidade = "Nenhum Perfil encontrado";
        break;
      case 1:
        state.labelQuantidade = "1 Perfil encontrado";
        break;
      default:
        state.labelQuantidade = `${payload.quantidade} Perfis encontrados`;
    }
  },
  limparPerfisListados(state) {
    state.listaPerfis = [];
  },
  limparPerfilPesquisa(state) {
    state.perfilPesquisa = { nome: undefined, pagina: 0 };
  },
  atualizarPerfilSelecionado(state, payload) {
    state.perfilSelecionado = payload;

    let clientesAluguel = state.perfilSelecionado.permissoes
      .filter((permissao) => {
        return permissao.modulo === "CLIENTES_ALUGUEL";
      })[0];

    // Preenchendo as checkboxes do grupo Aluguel -> Clientes
    state.grupoAluguelClientesCheckAll = false;
    state.grupoAluguelClientesChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_ALUGUEL_CLIENTES) {
      if(clientesAluguel[permissao]) {
        state.grupoAluguelClientesChecklist.push(permissao);
      }
    }
    // Preenchendo as checkboxes do grupo Aluguel -> Baixa do aluguel
    state.grupoAluguelBaixaCheckAll = false;
    state.grupoAluguelBaixaChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_ALUGUEL_BAIXA) {
      if(clientesAluguel[permissao]) {
        state.grupoAluguelBaixaChecklist.push(permissao);
      }
    }
    // Preenchendo as checkboxes do grupo Aluguel -> Liberação do repasse
    state.grupoAluguelLiberacaoRepasseCheckAll = false;
    state.grupoAluguelLiberacaoRepasseChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_ALUGUEL_LIBERACAO_REPASSE) {
      if(clientesAluguel[permissao]) {
        state.grupoAluguelLiberacaoRepasseChecklist.push(permissao);
      }
    }
    
    let imoveisAluguel = state.perfilSelecionado.permissoes
      .filter((permissao) => {
        return permissao.modulo === "IMOVEIS_ALUGUEL";
      })[0];

    // Preenchendo as checkboxes do grupo Aluguel -> Imóveis
    state.grupoAluguelImoveisCheckAll = false;
    state.grupoAluguelImoveisChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_ALUGUEL_IMOVEIS) {
      if(imoveisAluguel[permissao]) {
        state.grupoAluguelImoveisChecklist.push(permissao);
      }
    }

    let contratosAluguel = state.perfilSelecionado.permissoes
      .filter((permissao) => {
        return permissao.modulo === 'CONTRATOS_ALUGUEL'
      })[0];

    // Preenchendo as checkboxes do grupo Aluguel -> Contratos
    state.grupoAluguelContratosCheckAll = false;
    state.grupoAluguelContratosChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_ALUGUEL_CONTRATOS) {
      if(contratosAluguel[permissao]) {
        state.grupoAluguelContratosChecklist.push(permissao);
      }
    }
    // Preenchendo as checkboxes do grupo Aluguel -> Reajuste/Renovação/Prorrogação
    state.grupoAluguelReajusteCheckAll = false;
    state.grupoAluguelReajusteChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_ALUGUEL_REAJUSTE) {
      if(contratosAluguel[permissao]) {
        state.grupoAluguelReajusteChecklist.push(permissao);
      }
    }
    // Preenchendo as checkboxes do grupo Aluguel -> Vencimento/Carência/Tx. Adm
    state.grupoAluguelVencimentoCheckAll = false;
    state.grupoAluguelVencimentoChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_ALUGUEL_VENCIMENTO) {
      if(contratosAluguel[permissao]) {
        state.grupoAluguelVencimentoChecklist.push(permissao);
      }
    }

    let relatoriosClientesAluguel = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'RELATORIOS_CLIENTES_ALUGUEL'
      })[0];

    // Preenchendo a checkbox Relatórios de Aluguel -> Relatórios de Clientes
    state.grupoRelatoriosClientesChecklist = [];

    if(relatoriosClientesAluguel['visualizacao']) {
      state.grupoRelatoriosClientesChecklist.push('visualizacao');
    }

    let relatoriosContratosAluguel = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'RELATORIOS_CONTRATOS_ALUGUEL'
      })[0];

    // Preenchendo as checkboxes do grupo Relatórios de Aluguel -> Relatórios de Contratos
    state.grupoRelatoriosContratosCheckAll = false;
    state.grupoRelatoriosContratosChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_RELATORIOS_CONTRATOS) {
      if(relatoriosContratosAluguel[permissao]) {
        state.grupoRelatoriosContratosChecklist.push(permissao);
      }
    }

    let relatoriosImoveisAluguel = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'RELATORIOS_IMOVEIS_ALUGUEL'
      })[0];

    // Preenchendo as checkboxes do grupo Relatórios de Aluguel -> Relatórios de Imóveis
    state.grupoRelatoriosImoveisCheckAll = false;
    state.grupoRelatoriosImoveisChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_RELATORIOS_IMOVEIS) {
      if(relatoriosImoveisAluguel[permissao]) {
        state.grupoRelatoriosImoveisChecklist.push(permissao);
      }
    }

    let relatoriosPretendentesAluguel = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'RELATORIOS_PRETENDENTES_ALUGUEL'
      })[0];

    // Preenchendo a checkbox do grupo Relatórios de Aluguel -> Relatórios de Pretendentes
    state.grupoRelatoriosPretendentesChecklist = [];

    if(relatoriosPretendentesAluguel['visualizacao']) {
      state.grupoRelatoriosPretendentesChecklist.push('visualizacao');
    }

    let relatoriosFinanceirosAluguel = state.perfilSelecionado.permissoes
      .filter((permissao) => {
        return permissao.modulo === 'RELATORIOS_FINANCEIROS_ALUGUEL'
      })[0];

    // Preenchendo as checkboxes do grupo Relatórios de Aluguel -> Relatórios Financeiros
    state.grupoRelatoriosFinanceirosCheckAll = false;
    state.grupoRelatoriosFinanceirosChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_RELATORIOS_FINANCEIROS) {
      if(relatoriosFinanceirosAluguel[permissao]) {
        state.grupoRelatoriosFinanceirosChecklist.push(permissao);
      }
    }

    let clientesVenda = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'CLIENTES_VENDA'
      })[0];

    // Preenchendo as checkboxes do grupo Venda -> Clientes
    state.grupoVendaClientesCheckAll = false;
    state.grupoVendaClientesChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_VENDA_CLIENTES) {
      if(clientesVenda[permissao]) {
        state.grupoVendaClientesChecklist.push(permissao);
      }
    }

    let imoveisVenda = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'IMOVEIS_VENDA'
      })[0];

    // Preenchendo as checkboxes do grupo Venda -> Imóveis
    state.grupoVendaImoveisCheckAll = false;
    state.grupoVendaImoveisChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_VENDA_IMOVEIS) {
      if(imoveisVenda[permissao]) {
        state.grupoVendaImoveisChecklist.push(permissao);
      }
    }

    let contratosVenda = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'CONTRATOS_VENDA'
      })[0];

    // Preenchendo as checkboxes do grupo Venda -> Contratos
    state.grupoVendaContratosCheckAll = false;
    state.grupoVendaContratosChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_VENDA_CONTRATOS) {
      if(contratosVenda[permissao]) {
        state.grupoVendaContratosChecklist.push(permissao);
      }
    }

    let relatoriosCaptacoesVenda = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'RELATORIOS_CAPTACOES_VENDA'
      })[0];
    
    let relatoriosComissoesVenda = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'RELATORIOS_COMISSOES_VENDA'
      })[0];

    let relatoriosClientesVenda = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'RELATORIOS_CLIENTES_VENDA'
      })[0];

    let relatoriosImoveisVenda = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'RELATORIOS_IMOVEIS_VENDA'
      })[0];

    let relatoriosPretendentesVenda = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'RELATORIOS_PRETENDENTES_VENDA'
      })[0];

    // Preenchendo as checkboxes do grupo Venda -> Relatórios
    state.grupoVendaRelatoriosCheckAll = false;
    state.grupoVendaRelatoriosChecklist = [];

    if(relatoriosCaptacoesVenda['visualizacao']) {
      state.grupoVendaRelatoriosChecklist.push('captacoesVisualizacao');
    }
    if(relatoriosComissoesVenda['visualizacao']) {
      state.grupoVendaRelatoriosChecklist.push('comissoesVisualizacao');
    }
    if(relatoriosComissoesVenda['visualizacaoSomenteClientesCorretor']) {
      state.grupoVendaRelatoriosChecklist.push('visualizacaoSomenteClientesCorretor');
    }
    if(relatoriosClientesVenda['visualizacao']) {
      state.grupoVendaRelatoriosChecklist.push('clientesVisualizacao');
    }
    if(relatoriosImoveisVenda['visualizacao']) {
      state.grupoVendaRelatoriosChecklist.push('imoveisVisualizacao');
    }
    if(relatoriosPretendentesVenda['visualizacao']) {
      state.grupoVendaRelatoriosChecklist.push('pretendentesVisualizacao');
    }

    let contasReceber = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'CONTAS_RECEBER'
      })[0];

    // Preenchendo as checkboxes do grupo Financeiro -> Contas a Receber
    state.grupoFinanceiroContasReceberCheckAll = false;
    state.grupoFinanceiroContasReceberChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_FINANCEIRO_CONTAS_RECEBER) {
      if(contasReceber[permissao]) {
        state.grupoFinanceiroContasReceberChecklist.push(permissao);
      }
    }

    let lancamentosContasReceber = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'LANCAMENTOS_CONTAS_RECEBER'
      })[0];

    // Preenchendo as checkboxes do grupo Financeiro -> Lançamentos - Contas a Receber
    state.grupoFinanceiroLancamentosReceberCheckAll = false;
    state.grupoFinanceiroLancamentosReceberChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_FINANCEIRO_LANCAMENTOS_RECEBER) {
      if(lancamentosContasReceber[permissao]) {
        state.grupoFinanceiroLancamentosReceberChecklist.push(permissao);
      }
    }

    let contasPagar = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'CONTAS_PAGAR'
      })[0];

    // Preenchendo as checkboxes do grupo Financeiro -> Contas a Pagar
    state.grupoFinanceiroContasPagarCheckAll = false;
    state.grupoFinanceiroContasPagarChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_FINANCEIRO_CONTAS_PAGAR) {
      if(contasPagar[permissao]) {
        state.grupoFinanceiroContasPagarChecklist.push(permissao);
      }
    }

    let lancamentosContasPagar = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'LANCAMENTOS_CONTAS_PAGAR'
      })[0];

    // Preenchendo as checkboxes do grupo Financeiro -> Lançamentos - Contas a Pagar
    state.grupoFinanceiroLancamentosPagarCheckAll = false;
    state.grupoFinanceiroLancamentosPagarChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_FINANCEIRO_LANCAMENTOS_PAGAR) {
      if(lancamentosContasPagar[permissao]) {
        state.grupoFinanceiroLancamentosPagarChecklist.push(permissao);
      }
    }

    let caixa = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'CAIXA'
      })[0];

    // Preenchendo as checkboxes do grupo Financeiro -> Caixa
    state.grupoFinanceiroCaixaCheckAll = false;
    state.grupoFinanceiroCaixaChecklist = [];
    
    for(let permissao of GruposPermissoes.PERMISSOES_FINANCEIRO_CAIXA) {
      if(caixa[permissao]) {
        state.grupoFinanceiroCaixaChecklist.push(permissao);
      }
    }

    let fornecedores = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'FORNECEDORES'
      })[0];

    // Preenchendo as checkboxes do grupo Financeiro -> Fornecedores
    state.grupoFinanceiroFornecedoresCheckAll = false;
    state.grupoFinanceiroFornecedoresChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_FINANCEIRO_FORNECEDORES) {
      if(fornecedores[permissao]) {
        state.grupoFinanceiroFornecedoresChecklist.push(permissao);
      }
    }

    let planosConta = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'PLANOS_CONTA'
      })[0];

    // Preenchendo as checkboxes do grupo Financeiro -> Planos de Conta
    state.grupoFinanceiroPlanosContaCheckAll = false;
    state.grupoFinanceiroPlanosContaChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_FINANCEIRO_PLANOS_CONTA) {
      if(planosConta[permissao]) {
        state.grupoFinanceiroPlanosContaChecklist.push(permissao);
      }
    }

    let gruposConta = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'GRUPOS_CONTA'
      })[0];

    // Preenchendo as checkboxes do grupo Financeiro -> Grupos de Conta
    state.grupoFinanceiroGruposContaCheckAll = false;
    state.grupoFinanceiroGruposContaChecklist = [];

    if(contasPagar) {
      if(contasPagar['relatorioContasPagas']) {
        state.grupoFinanceiroRelatoriosChecklist.push('relatorioContasPagas');
      }
    }

    if(contasPagar) {
      if(contasPagar['relatorioContasAPagar']) {
        state.grupoFinanceiroRelatoriosChecklist.push('relatorioContasAPagar');
      }
    }

    if(contasPagar) {
      if(contasPagar['relatorioContasAPagarVencidas']) {
        state.grupoFinanceiroRelatoriosChecklist.push('relatorioContasAPagarVencidas');
      }
    }

    if(contasReceber) {
      if(contasReceber['relatorioContasRecebidas']) {
        state.grupoFinanceiroRelatoriosChecklist.push('relatorioContasRecebidas');
      }
    }

    if(contasReceber) {
      if(contasReceber['relatorioContasAReceber']) {
        state.grupoFinanceiroRelatoriosChecklist.push('relatorioContasAReceber');
      }
    }

    if(contasReceber) {
      if(contasReceber['relatorioContasAReceberVencidas']) {
        state.grupoFinanceiroRelatoriosChecklist.push('relatorioContasAReceberVencidas');
      }
    }

    if(contasReceber) {
      if(contasReceber['relatorioCheques']) {
        state.grupoFinanceiroRelatoriosChecklist.push('relatorioCheques');
      }
    }
    
    for(let permissao of GruposPermissoes.PERMISSOES_FINANCEIRO_GRUPOS_CONTA) {
      if(gruposConta[permissao]) {
        state.grupoFinanceiroGruposContaChecklist.push(permissao);
      }
    }

    let pretendentes = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'PRETENDENTES'
      })[0];

    // Preenchendo as checkboxes do grupo Configurações -> Pretendentes
    state.grupoConfiguracoesPretendentesCheckAll = false;
    state.grupoConfiguracoesPretendentesChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_CONFIGURACOES_PRETENDENTES) {
      if(pretendentes[permissao]) {
        state.grupoConfiguracoesPretendentesChecklist.push(permissao);
      }
    }

    let condominios = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'CONDOMINIOS'
      })[0];

    // Preenchendo as checkboxes do grupo Configurações -> Condomínios
    state.grupoConfiguracoesCondominiosCheckAll = false;
    state.grupoConfiguracoesCondominiosChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_CONFIGURACOES_CONDOMINIOS) {
      if(condominios[permissao]) {
        state.grupoConfiguracoesCondominiosChecklist.push(permissao);
      }
    }

    let administradoras = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'ADMINISTRADORAS'
      })[0];

    // Preenchendo as checkboxes do grupo Configurações -> Administradoras
    state.grupoConfiguracoesAdministradorasCheckAll = false;
    state.grupoConfiguracoesAdministradorasChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_CONFIGURACOES_ADMINISTRADORAS) {
      if(administradoras[permissao]) {
        state.grupoConfiguracoesAdministradorasChecklist.push(permissao);
      }
    }

    let usuarios = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'USUARIOS'
      })[0];

    // Preenchendo as checkboxes do grupo Configurações -> Usuários
    state.grupoConfiguracoesUsuariosCheckAll = false;
    state.grupoConfiguracoesUsuariosChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_CONFIGURACOES_USUARIOS) {
      if(usuarios[permissao]) {
        state.grupoConfiguracoesUsuariosChecklist.push(permissao);
      }
    }

    let perfisUsuarios = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'PERFIS_USUARIOS'
      })[0];

    // Preenchendo as checkboxes do grupo Configurações -> Perfis
    state.grupoConfiguracoesPerfisCheckAll = false;
    state.grupoConfiguracoesPerfisChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_CONFIGURACOES_PERFIS) {
      if(perfisUsuarios[permissao]) {
        state.grupoConfiguracoesPerfisChecklist.push(permissao);
      }
    }

    let placas = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'PLACAS'
      })[0];

    // Preenchendo as checkboxes do grupo Configurações -> Placas
    state.grupoConfiguracoesPlacasCheckAll = false;
    state.grupoConfiguracoesPlacasChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_CONFIGURACOES_PLACAS) {
      if(placas[permissao]) {
        state.grupoConfiguracoesPlacasChecklist.push(permissao);
      }
    }

    let contasBancarias = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'CONTAS_BANCARIAS'
      })[0];

    // Preenchendo as checkboxes do grupo Configurações -> Contas Bancárias
    state.grupoConfiguracoesContasCheckAll = false;
    state.grupoConfiguracoesContasChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_CONFIGURACOES_CONTAS) {
      if(contasBancarias[permissao]) {
        state.grupoConfiguracoesContasChecklist.push(permissao);
      }
    }

    let portais = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'PORTAIS'
      })[0];

    // Preenchendo as checkboxes do grupo Configurações -> Portais/Site
    state.grupoConfiguracoesPortaisCheckAll = false;
    state.grupoConfiguracoesPortaisChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_CONFIGURACOES_PORTAIS) {
      if(portais[permissao]) {
        state.grupoConfiguracoesPortaisChecklist.push(permissao);
      }
    }

    let logs = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'LOGS'
      })[0];

    // Preenchendo as checkboxes do grupo Configurações -> Logs de Acesso
    state.grupoConfiguracoesLogsCheckAll = false;
    state.grupoConfiguracoesLogsChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_CONFIGURACOES_LOGS) {
      if(logs[permissao]) {
        state.grupoConfiguracoesLogsChecklist.push(permissao);
      }
    }

    let visita = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'VISITA'
      })[0];

    // Preenchendo as checkboxes do grupo Configurações -> Visitas
    state.grupoConfiguracoesVisitasCheckAll = false;
    state.grupoConfiguracoesVisitasChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_CONFIGURACOES_VISITAS) {
      if(visita[permissao]) {
        state.grupoConfiguracoesVisitasChecklist.push(permissao);
      }
    }

    let sistema = state.perfilSelecionado.permissoes
      .filter((item) => {
        return item.modulo === 'SISTEMA'
      })[0];

    // Preenchendo as checkboxes do grupo Configurações -> Sistema
    state.grupoConfiguracoesSistemaCheckAll = false;
    state.grupoConfiguracoesSistemaChecklist = [];

    for(let permissao of GruposPermissoes.PERMISSOES_CONFIGURACOES_SISTEMA) {
      if(sistema[permissao]) {
        state.grupoConfiguracoesSistemaChecklist.push(permissao);
      }
    }
  },
  limparPerfilSelecionado(state) {
    state.perfilSelecionado = {
      id: 0,
      nome: undefined,
      permissoes: [
        { modulo: 'CLIENTES_ALUGUEL' },
        { modulo: 'IMOVEIS_ALUGUEL' },
        { modulo: 'CONTRATOS_ALUGUEL' },
        { modulo: 'RELATORIOS_CLIENTES_ALUGUEL' },
        { modulo: 'RELATORIOS_CONTRATOS_ALUGUEL' },
        { modulo: 'RELATORIOS_IMOVEIS_ALUGUEL' },
        { modulo: 'RELATORIOS_PRETENDENTES_ALUGUEL' },
        { modulo: 'RELATORIOS_FINANCEIROS_ALUGUEL' },
        { modulo: 'CLIENTES_VENDA' },
        { modulo: 'CONTRATOS_VENDA' },
        { modulo: 'IMOVEIS_VENDA' },
        { modulo: 'RELATORIOS_CAPTACOES_VENDA' },
        { modulo: 'RELATORIOS_COMISSOES_VENDA' },
        { modulo: 'RELATORIOS_CLIENTES_VENDA' },
        { modulo: 'RELATORIOS_IMOVEIS_VENDA' },
        { modulo: 'RELATORIOS_PRETENDENTES_VENDA' },
        { modulo: 'CONTAS_RECEBER' },
        { modulo: 'LANCAMENTOS_CONTAS_RECEBER' },
        { modulo: 'CONTAS_PAGAR' },
        { modulo: 'LANCAMENTOS_CONTAS_PAGAR' },
        { modulo: 'CAIXA' },
        { modulo: 'FORNECEDORES' },
        { modulo: 'PLANOS_CONTA' },
        { modulo: 'GRUPOS_CONTA' },
        { modulo: 'PRETENDENTES' },
        { modulo: 'ADMINISTRADORAS' },
        { modulo: 'CONDOMINIOS' },
        { modulo: 'PLACAS' },
        { modulo: 'USUARIOS' },
        { modulo: 'PERFIS_USUARIOS' },
        { modulo: 'CONTAS_BANCARIAS' },
        { modulo: 'PORTAIS' },
        { modulo: 'LOGS' },
        { modulo: 'VISITA' },
        { modulo: 'SISTEMA' }
      ],
      widgets: Object.assign({}, widgets)
    };

    state.grupoAluguelClientesCheckAll = false;
    state.grupoAluguelClientesChecklist = [];

    state.grupoAluguelBaixaCheckAll = false;
    state.grupoAluguelBaixaChecklist = [];

    state.grupoAluguelLiberacaoRepasseCheckAll = false;
    state.grupoAluguelLiberacaoRepasseChecklist = [];

    state.grupoAluguelImoveisCheckAll = false;
    state.grupoAluguelImoveisChecklist = [];

    state.grupoAluguelContratosCheckAll = false;
    state.grupoAluguelContratosChecklist = [];

    state.grupoAluguelReajusteCheckAll = false;
    state.grupoAluguelReajusteChecklist = [];

    state.grupoAluguelVencimentoCheckAll = false;
    state.grupoAluguelVencimentoChecklist = [];

    state.grupoRelatoriosClientesChecklist = [];

    state.grupoRelatoriosContratosCheckAll = false;
    state.grupoRelatoriosContratosChecklist = [];

    state.grupoRelatoriosImoveisCheckAll = false;
    state.grupoRelatoriosImoveisChecklist = [];

    state.grupoRelatoriosPretendentesChecklist = [];

    state.grupoRelatoriosFinanceirosCheckAll = false;
    state.grupoRelatoriosFinanceirosChecklist = [];

    state.grupoVendaClientesCheckAll = false;
    state.grupoVendaClientesChecklist = [];

    state.grupoVendaImoveisCheckAll = false;
    state.grupoVendaImoveisChecklist = [];

    state.grupoVendaContratosCheckAll = false;
    state.grupoVendaContratosChecklist = [];

    state.grupoVendaRelatoriosCheckAll = false;
    state.grupoVendaRelatoriosChecklist = [];

    state.grupoFinanceiroContasReceberCheckAll = false;
    state.grupoFinanceiroContasReceberChecklist = [];

    state.grupoFinanceiroLancamentosReceberCheckAll = false;
    state.grupoFinanceiroLancamentosReceberChecklist = [];

    state.grupoFinanceiroContasPagarCheckAll = false;
    state.grupoFinanceiroContasPagarChecklist = [];

    state.grupoFinanceiroLancamentosPagarCheckAll = false;
    state.grupoFinanceiroLancamentosPagarChecklist = [];

    state.grupoFinanceiroCaixaCheckAll = false;
    state.grupoFinanceiroCaixaChecklist = [];

    state.grupoFinanceiroFornecedoresCheckAll = false;
    state.grupoFinanceiroFornecedoresChecklist = [];

    state.grupoFinanceiroPlanosContaCheckAll = false;
    state.grupoFinanceiroPlanosContaChecklist = [];

    state.grupoFinanceiroGruposContaCheckAll = false;
    state.grupoFinanceiroGruposContaChecklist = [];

    state.grupoFinanceiroRelatoriosCheckAll = false;
    state.grupoFinanceiroRelatoriosChecklist = [];

    state.grupoConfiguracoesPretendentesCheckAll = false;
    state.grupoConfiguracoesPretendentesChecklist = [];

    state.grupoConfiguracoesCondominiosCheckAll = false;
    state.grupoConfiguracoesCondominiosChecklist = [];

    state.grupoConfiguracoesAdministradorasCheckAll = false;
    state.grupoConfiguracoesAdministradorasChecklist = [];

    state.grupoConfiguracoesUsuariosCheckAll = false;
    state.grupoConfiguracoesUsuariosChecklist = [];

    state.grupoConfiguracoesPerfisCheckAll = false;
    state.grupoConfiguracoesPerfisChecklist = [];

    state.grupoConfiguracoesPlacasCheckAll = false;
    state.grupoConfiguracoesPlacasChecklist = [];

    state.grupoConfiguracoesContasCheckAll = false;
    state.grupoConfiguracoesContasChecklist = [];

    state.grupoConfiguracoesPortaisCheckAll = false;
    state.grupoConfiguracoesPortaisChecklist = [];

    state.grupoConfiguracoesLogsCheckAll = false;
    state.grupoConfiguracoesLogsChecklist = [];

    state.grupoConfiguracoesVisitasCheckAll = false;
    state.grupoConfiguracoesVisitasChecklist = [];

    state.grupoConfiguracoesSistemaCheckAll = false;
    state.grupoConfiguracoesSistemaChecklist = [];
  },
  setGrupoAluguelClientesCheckAll(state, value) {
    state.grupoAluguelClientesCheckAll = value;
  },
  setGrupoAluguelClientesChecklist(state, value) {
    state.grupoAluguelClientesChecklist = value;
  },

  setGrupoAluguelBaixaCheckAll(state, value) {
    state.grupoAluguelBaixaCheckAll = value;
  },
  setGrupoAluguelBaixaChecklist(state, value) {
    state.grupoAluguelBaixaChecklist = value;
  },

  setGrupoAluguelLiberacaoRepasseCheckAll(state, value) {
    state.grupoAluguelLiberacaoRepasseCheckAll = value;
  },
  setGrupoAluguelLiberacaoRepasseChecklist(state, value) {
    state.grupoAluguelLiberacaoRepasseChecklist = value;
  },

  setGrupoAluguelImoveisCheckAll(state, value) {
    state.grupoAluguelImoveisCheckAll = value;
  },
  setGrupoAluguelImoveisChecklist(state, value) {
    state.grupoAluguelImoveisChecklist = value;
  },

  setGrupoAluguelContratosCheckAll(state, value) {
    state.grupoAluguelContratosCheckAll = value;
  },
  setGrupoAluguelContratosChecklist(state, value) {
    state.grupoAluguelContratosChecklist = value;
  },

  setGrupoAluguelReajusteCheckAll(state, value) {
    state.grupoAluguelReajusteCheckAll = value;
  },
  setGrupoAluguelReajusteChecklist(state, value) {
    state.grupoAluguelReajusteChecklist = value;
  },

  setGrupoAluguelVencimentoCheckAll(state, value) {
    state.grupoAluguelVencimentoCheckAll = value;
  },
  setGrupoAluguelVencimentoChecklist(state, value) {
    state.grupoAluguelVencimentoChecklist = value;
  },

  setGrupoRelatoriosClientesChecklist(state, value) {
    state.grupoRelatoriosClientesChecklist = value;
  },

  setGrupoRelatoriosContratosCheckAll(state, value) {
    state.grupoRelatoriosContratosCheckAll = value;
  },
  setGrupoRelatoriosContratosChecklist(state, value) {
    state.grupoRelatoriosContratosChecklist = value;
  },

  setGrupoRelatoriosImoveisCheckAll(state, value) {
    state.grupoRelatoriosImoveisCheckAll = value;
  },
  setGrupoRelatoriosImoveisChecklist(state, value) {
    state.grupoRelatoriosImoveisChecklist = value;
  },

  setGrupoRelatoriosPretendentesChecklist(state, value) {
    state.grupoRelatoriosPretendentesChecklist = value;
  },

  setGrupoRelatoriosFinanceirosCheckAll(state, value) {
    state.grupoRelatoriosFinanceirosCheckAll = value;
  },
  setGrupoRelatoriosFinanceirosChecklist(state, value) {
    state.grupoRelatoriosFinanceirosChecklist = value;
  },

  setGrupoVendaClientesCheckAll(state, value) {
    state.grupoVendaClientesCheckAll = value;
  },
  setGrupoVendaClientesChecklist(state, value) {
    state.grupoVendaClientesChecklist = value;
  },

  setGrupoVendaImoveisCheckAll(state, value) {
    state.grupoVendaImoveisCheckAll = value;
  },
  setGrupoVendaImoveisChecklist(state, value) {
    state.grupoVendaImoveisChecklist = value;
  },

  setGrupoVendaContratosCheckAll(state, value) {
    state.grupoVendaContratosCheckAll = value;
  },
  setGrupoVendaContratosChecklist(state, value) {
    state.grupoVendaContratosChecklist = value;
  },

  setGrupoVendaRelatoriosCheckAll(state, value) {
    state.grupoVendaRelatoriosCheckAll = value;
  },
  setGrupoVendaRelatoriosChecklist(state, value) {
    state.grupoVendaRelatoriosChecklist = value;
  },

  setGrupoFinanceiroContasReceberCheckAll(state, value) {
    state.grupoFinanceiroContasReceberCheckAll = value;
  },
  setGrupoFinanceiroContasReceberChecklist(state, value) {
    state.grupoFinanceiroContasReceberChecklist = value;
  },

  setGrupoFinanceiroLancamentosReceberCheckAll(state, value) {
    state.grupoFinanceiroLancamentosReceberCheckAll = value;
  },
  setGrupoFinanceiroLancamentosReceberChecklist(state, value) {
    state.grupoFinanceiroLancamentosReceberChecklist = value;
  },

  setGrupoFinanceiroContasPagarCheckAll(state, value) {
    state.grupoFinanceiroContasPagarCheckAll = value;
  },
  setGrupoFinanceiroContasPagarChecklist(state, value) {
    state.grupoFinanceiroContasPagarChecklist = value;
  },

  setGrupoFinanceiroLancamentosPagarCheckAll(state, value) {
    state.grupoFinanceiroLancamentosPagarCheckAll = value;
  },
  setGrupoFinanceiroLancamentosPagarChecklist(state, value) {
    state.grupoFinanceiroLancamentosPagarChecklist = value;
  },

  setGrupoFinanceiroCaixaCheckAll(state, value) {
    state.grupoFinanceiroCaixaCheckAll = value;
  },
  setGrupoFinanceiroCaixaChecklist(state, value) {
    state.grupoFinanceiroCaixaChecklist = value;
  },

  setGrupoFinanceiroFornecedoresCheckAll(state, value) {
    state.grupoFinanceiroFornecedoresCheckAll = value;
  },
  setGrupoFinanceiroFornecedoresChecklist(state, value) {
    state.grupoFinanceiroFornecedoresChecklist = value;
  },

  setGrupoFinanceiroPlanosContaCheckAll(state, value) {
    state.grupoFinanceiroPlanosContaCheckAll = value;
  },
  setGrupoFinanceiroPlanosContaChecklist(state, value) {
    state.grupoFinanceiroPlanosContaChecklist = value;
  },

  setGrupoFinanceiroGruposContaCheckAll(state, value) {
    state.grupoFinanceiroGruposContaCheckAll = value;
  },
  setGrupoFinanceiroGruposContaChecklist(state, value) {
    state.grupoFinanceiroGruposContaChecklist = value;
  },

  setGrupoFinanceiroRelatoriosCheckAll(state, value) {
    state.grupoFinanceiroRelatoriosCheckAll = value;
  },
  setGrupoFinanceiroRelatoriosChecklist(state, value) {
    state.grupoFinanceiroRelatoriosChecklist = value;
  },

  setGrupoConfiguracoesPretendentesCheckAll(state, value) {
    state.grupoConfiguracoesPretendentesCheckAll = value;
  },
  setGrupoConfiguracoesPretendentesChecklist(state, value) {
    state.grupoConfiguracoesPretendentesChecklist = value;
  },

  setGrupoConfiguracoesCondominiosCheckAll(state, value) {
    state.grupoConfiguracoesCondominiosCheckAll = value;
  },
  setGrupoConfiguracoesCondominiosChecklist(state, value) {
    state.grupoConfiguracoesCondominiosChecklist = value;
  },

  setGrupoConfiguracoesAdministradorasCheckAll(state, value) {
    state.grupoConfiguracoesAdministradorasCheckAll = value;
  },
  setGrupoConfiguracoesAdministradorasChecklist(state, value) {
    state.grupoConfiguracoesAdministradorasChecklist = value;
  },

  setGrupoConfiguracoesUsuariosCheckAll(state, value) {
    state.grupoConfiguracoesUsuariosCheckAll = value;
  },
  setGrupoConfiguracoesUsuariosChecklist(state, value) {
    state.grupoConfiguracoesUsuariosChecklist = value;
  },

  setGrupoConfiguracoesPerfisCheckAll(state, value) {
    state.grupoConfiguracoesPerfisCheckAll = value;
  },
  setGrupoConfiguracoesPerfisChecklist(state, value) {
    state.grupoConfiguracoesPerfisChecklist = value;
  },

  setGrupoConfiguracoesPlacasCheckAll(state, value) {
    state.grupoConfiguracoesPlacasCheckAll = value;
  },
  setGrupoConfiguracoesPlacasChecklist(state, value) {
    state.grupoConfiguracoesPlacasChecklist = value;
  },

  setGrupoConfiguracoesContasCheckAll(state, value) {
    state.grupoConfiguracoesContasCheckAll = value;
  },
  setGrupoConfiguracoesContasChecklist(state, value) {
    state.grupoConfiguracoesContasChecklist = value;
  },

  setGrupoConfiguracoesPortaisCheckAll(state, value) {
    state.grupoConfiguracoesPortaisCheckAll = value;
  },
  setGrupoConfiguracoesPortaisChecklist(state, value) {
    state.grupoConfiguracoesPortaisChecklist = value;
  },

  setGrupoConfiguracoesLogsCheckAll(state, value) {
    state.grupoConfiguracoesLogsCheckAll = value;
  },
  setGrupoConfiguracoesLogsChecklist(state, value) {
    state.grupoConfiguracoesLogsChecklist = value;
  },

  setGrupoConfiguracoesVisitasCheckAll(state, value) {
    state.grupoConfiguracoesVisitasCheckAll = value;
  },
  setGrupoConfiguracoesVisitasChecklist(state, value) {
    state.grupoConfiguracoesVisitasChecklist = value;
  },

  setGrupoConfiguracoesSistemaCheckAll(state, value) {
    state.grupoConfiguracoesSistemaCheckAll = value;
  },
  setGrupoConfiguracoesSistemaChecklist(state, value) {
    state.grupoConfiguracoesSistemaChecklist = value;
  }
};
const actions = {
  listarPerfis(context, payload) {
    return axios.post(URLS.PERFIS_USUARIO_LISTAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarListaPerfis', response.data);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('listarPerfis', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },
  limparPerfisListados(context) {
    context.commit('limparPerfisListados');
  },
  limparPerfilPesquisa(context) {
    context.commit('limparPerfilPesquisa');
  },
  recuperarPerfil(context, payload) {
    return axios.post(URLS.PERFIS_USUARIO_RECUPERAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarPerfilSelecionado', response.data.item);
            break;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('recuperarPerfil', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },
  limparPerfilSelecionado(context) {
    context.commit('limparPerfilSelecionado');
  },
  gravarPerfil(context, payload) {
    return axios.post(URLS.PERFIS_USUARIO_GRAVAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarPerfilSelecionado', response.data.item);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('gravarPerfil', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },
  removerPerfil(context, payload) {
    return axios.post(URLS.PERFIS_USUARIO_REMOVER, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('limparPerfilSelecionado');
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('removerPerfil', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  }
};

export default {
  state,
  mutations,
  actions
};